import Immutable from 'immutable';


export const GET_TRACKING = 'takeback/api/TRACKING';
export const GET_TRACKING_SUCCESS = 'takeback/api/TRACKING_SUCCESS';
export const GET_TRACKING_FAILURE = 'takeback/api/TRACKING_FAILURE';


const initialState = Immutable.OrderedMap();


// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_TRACKING_SUCCESS:
        return state.set('code', action.order.get('code'));
    default:
        return state;

    }
}

export function getTrackingSuccess(order) {
    return { type: GET_TRACKING_SUCCESS, order };
}

export function getTrackingFailure(error) {
    return { type: GET_TRACKING_FAILURE, error };
}
